var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loading
    ? _c("div", { staticClass: "yj-data-empty" }, [
        _c("img", {
          attrs: {
            src: require("@/v3/assets/img/yj-loading.gif"),
            width: "64px",
          },
        }),
        _c("p", { staticClass: "empty-text" }, [
          _vm._v(" " + _vm._s(_vm.loadingTip) + " "),
        ]),
      ])
    : _c("div", { staticClass: "yj-data-empty" }, [
        _c("img", {
          attrs: {
            src: require("@/v3/assets/img/yj-empty.png"),
            width: "190px",
          },
        }),
        _vm.emptyTip
          ? _c("p", { staticClass: "empty-text" }, [
              _vm._v(" " + _vm._s(_vm.emptyTip) + " "),
            ])
          : _c("div", { staticClass: "empty-text" }, [_vm._t("default")], 2),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }